import React, { useState } from "react";
import "./OfferCard.scss";
import { toast } from "react-toastify";

const OfferCard = ({ offer, code, details }) => {
  const [showDetails, setShowDetails] = useState(false);
  const [couponCopied, setCouponCopied] = useState(false);

  const handleMouseEnter = () => {
    setShowDetails(true);
  };

  const handleMouseLeave = () => {
    setShowDetails(false);
  };

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(code);
    setCouponCopied(true);
    toast.success("Coupon code copied to clipboard!", {
      position: "bottom-right",
      autoClose: 3000,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
      transitions: "Zoom",
    });
    setTimeout(() => setCouponCopied(false), 3000);
  };

  return (
    <div className="offerCard">
      <div className="top-container">
        <p className="shopText">Shop Now & Get</p>

        {/* Info Icon with hover effect */}
        <div
          className="infoIcon"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={() => setShowDetails(!showDetails)}
        >
          <i class="bi bi-info-circle"></i>

          {showDetails && (
            <div className="detailsPopup">
              <p>{details}</p>
            </div>
          )}
        </div>
      </div>

      <h4>{offer}</h4>

      <div className="couponCodeContainer">
        <h6>Code: {code}</h6>

        <div
          className="copy-button"
          onClick={() => {
            if (!couponCopied) handleCopyToClipboard();
          }}
        >
          {couponCopied ? (
            <i class="bi bi-clipboard2-check-fill" color="green"></i>
          ) : (
            <i class="bi bi-copy"></i>
          )}
        </div>
      </div>
    </div>
  );
};

export default OfferCard;
